var $264cd81c52b30815$exports = {};
$264cd81c52b30815$exports = {
  "alpha": "Alfa",
  "black": "crno",
  "blue": "Plava",
  "blue purple": "plavoljubi\u010Dasta",
  "brightness": "Osvetljenost",
  "brown": "sme\u0111a",
  "brown yellow": "sme\u0111e\u017Euta",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cijan",
  "cyan blue": "cijan plava",
  "dark": "tamno",
  "gray": "siva",
  "grayish": "sivkasta",
  "green": "Zelena",
  "green cyan": "zeleno cijan",
  "hue": "Nijansa",
  "light": "svetla",
  "lightness": "Osvetljenje",
  "magenta": "purpurnocrvena",
  "magenta pink": "magenta ru\u017Ei\u010Dasta",
  "orange": "narand\u017Easta",
  "orange yellow": "narand\u017Easto\u017Euta",
  "pale": "bledo",
  "pink": "ru\u017Ei\u010Dasta",
  "pink red": "ru\u017Ei\u010Dastocrvena",
  "purple": "ljubi\u010Dasta",
  "purple magenta": "ljubi\u010Dasta magenta",
  "red": "Crvena",
  "red orange": "crvenonarand\u017Easta",
  "saturation": "Zasi\u0107enje",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " prozirna");
  },
  "very dark": "veoma tamno",
  "very light": "vrlo svetlo",
  "vibrant": "\u017Eivopisna",
  "white": "bela",
  "yellow": "\u017Euto",
  "yellow green": "\u017Eutozelena"
};
export { $264cd81c52b30815$exports as default };